"use client";

import { useState } from "react";
import thumbna from "../../../assets/thumb2.jpg";
import instructorImg from "../../../assets/abhishek.jpg";
import { useNavigate } from "react-router-dom";
import certificateImg from "../../../assets/certificate privew.jpg";

// Placeholder images
// const thumbnail = {thumbna}
// const instructorImage = {instructorImg}

function CourseDetails() {
  const [expandedModule, setExpandedModule] = useState(0);

  const [showVideo, setShowVideo] = useState(false);
  const navigate = useNavigate(); // if you're using react-router

  // const handleOpenVideo = () => setShowVideo(true);
  const handleCloseVideo = () => setShowVideo(false);
  // Sample course data
  const course = {
    title: "How to Earn up to 50K Per Month by Working from Home",
    subtitle:
      "Master digital work-from-home skills and build a sustainable income stream",
    rating: 4.9,
    students: 5123,
    lastUpdated: "April 2025",
    duration: "20 hours",
    modules: [
      {
        id: 1,
        title: "Introduction to Work From Home Opportunities",
        duration: "2 hours",
        lessons: [
          {
            title: "Welcome and Course Overview",
            duration: "10 min",
            isVideo: true,
          },
          {
            title: "Is Work from Home Right for You?",
            duration: "20 min",
            isVideo: true,
          },
          {
            title: "Understanding Your Skills and Goals",
            duration: "25 min",
            isVideo: true,
          },
          {
            title: "Types of Work-from-Home Jobs",
            duration: "45 min",
            isVideo: true,
          },
          { title: "Module Assignment", duration: "20 min", isVideo: false },
        ],
      },
      {
        id: 2,
        title: "Popular Work From Home Jobs & Platforms",
        duration: "3 hours",
        lessons: [
          {
            title: "Freelancing on Upwork & Fiverr",
            duration: "45 min",
            isVideo: true,
          },
          {
            title: "Data Entry & Virtual Assistance",
            duration: "50 min",
            isVideo: true,
          },
          {
            title: "Affiliate Marketing & Blogging",
            duration: "40 min",
            isVideo: true,
          },
          {
            title: "Remote Customer Support Jobs",
            duration: "30 min",
            isVideo: true,
          },
          {
            title: "Microtasking & Survey Sites",
            duration: "30 min",
            isVideo: true,
          },
          { title: "Module Challenge", duration: "25 min", isVideo: false },
        ],
      },
      {
        id: 3,
        title: "Building Your Online Presence",
        duration: "3 hours 30 minutes",
        lessons: [
          {
            title: "Creating a Winning Freelance Profile",
            duration: "40 min",
            isVideo: true,
          },
          {
            title: "Personal Branding on Social Media",
            duration: "45 min",
            isVideo: true,
          },
          {
            title: "Portfolio Building for Beginners",
            duration: "40 min",
            isVideo: true,
          },
          {
            title: "Resume & Cover Letter Writing",
            duration: "35 min",
            isVideo: true,
          },
          {
            title: "Mock Interview Practice",
            duration: "30 min",
            isVideo: true,
          },
        ],
      },
      {
        id: 4,
        title: "Getting Your First Job and Scaling",
        duration: "5 hours",
        lessons: [
          {
            title: "How to Apply and Get Shortlisted",
            duration: "45 min",
            isVideo: true,
          },
          {
            title: "Client Communication & Etiquette",
            duration: "40 min",
            isVideo: true,
          },
          {
            title: "Managing Your Time and Workload",
            duration: "50 min",
            isVideo: true,
          },
          {
            title: "Scaling to Multiple Clients",
            duration: "60 min",
            isVideo: true,
          },
          {
            title: "Monthly Income Planning",
            duration: "45 min",
            isVideo: true,
          },
          { title: "Final Project", duration: "60 min", isVideo: false },
        ],
      },
      {
        id: 5,
        title: "Bonus: Passive Income & Automation",
        duration: "3 hours 30 minutes",
        lessons: [
          {
            title: "Introduction to Passive Income",
            duration: "35 min",
            isVideo: true,
          },
          {
            title: "Automating Repetitive Work",
            duration: "40 min",
            isVideo: true,
          },
          {
            title: "Online Course & Digital Products",
            duration: "45 min",
            isVideo: true,
          },
          {
            title: "Tips for Financial Growth",
            duration: "30 min",
            isVideo: true,
          },
          {
            title: "Module Summary & Final Words",
            duration: "20 min",
            isVideo: false,
          },
        ],
      },
    ],
    instructor: {
      name: "Abhishek Sharma",
      title: "Online Business Coach",
      bio: "Abhishek Sharma is a seasoned online entrepreneur who has helped thousands of people start and scale work-from-home careers. His passion lies in making financial freedom accessible through practical skills.",
      courses: 9,
      students: 50000,
      rating: 4.9,
    },
    about:
      "This course is designed to empower individuals with the tools and strategies needed to earn a stable income working from home. Learn everything from freelancing and virtual jobs to building passive income streams — all through real-world practical modules.",
    whatYouWillLearn: [
      "Discover real work-from-home job opportunities",
      "Learn how to build a strong freelance profile",
      "Master time and client management skills",
      "Create multiple income streams",
      "Build a personal brand and online presence",
      "Automate repetitive work and boost productivity",
      "Explore passive income strategies",
    ],
    certificate: {
      title: "Course Completion Certificate",
      description:
        "Earn a certificate after successfully completing the course and its final project. Perfect for showcasing your skills to clients and employers.",
      requirements:
        "Watch all lessons, complete assignments, and submit the final project.",
    },
    price: {
      original: 20000,
      discounted: 14999,
      discount: 25,
    },
  };

  const toggleModule = (moduleId) => {
    if (expandedModule === moduleId) {
      setExpandedModule(null);
    } else {
      setExpandedModule(moduleId);
    }
  };

  return (
    <div className="bg-gray-900 text-white min-h-screen">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-900/80 to-purple-900/80 z-10"></div>
        <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="inline-block px-4 py-2 bg-indigo-600 text-white rounded-full text-sm font-bold uppercase tracking-wide animate-pulse">
                Limited Time Launch Offer
              </div>
              <h1 className="text-5xl lg:text-6xl font-extrabold leading-tight">
                {course.title}
              </h1>
              <p className="text-xl text-gray-300">{course.subtitle}</p>
              <div className="flex flex-wrap gap-4 text-gray-300">
                <div className="flex items-center">
                  <svg
                    className="h-5 w-5 text-yellow-400 mr-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118 1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81 .588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    <span>
                      {course.rating} ({course.students.toLocaleString()}{" "}
                      students)
                    </span>
                  </svg>
                </div>
                <div className="flex items-center">
                  <svg
                    className="h-5 w-5 mr-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                      clipRule="evenodd"
                    />
                    <span>{course.duration}</span>
                  </svg>
                </div>
                <div className="flex items-center">
                  <svg
                    className="h-5 w-5 mr-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                      clipRule="evenodd"
                    />
                    <span>Last updated: {course.lastUpdated}</span>
                  </svg>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  onClick={() => alert("ERROR! Server is busy, Please Contact For support")}
                  className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-bold py-4 px-8 rounded-xl hover:from-indigo-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 shadow-lg"
                >
                  Enroll Now - ₹{course.price.discounted}
                </button>
                <button
                  // onClick={handleOpenVideo}
                  className="bg-gray-800 text-white font-bold py-4 px-8 rounded-xl hover:bg-gray-700 transition-all duration-300 border border-gray-600"
                >
                  Watch Preview
                </button>
              </div>
            </div>
            <div className="relative">
              <img 
                src={thumbna}
                alt="Course Thumbnail"
                className="rounded-2xl shadow-2xl w-full object-cover h-[400px] transform hover:scale-105 transition-all duration-500"
              />
              <div
                // onClick={handleOpenVideo}
                className="absolute inset-0 flex items-center justify-center"
              >
                <div className="bg-white/30 backdrop-blur-md p-6 rounded-full cursor-pointer hover:bg-white/40 transition-all duration-300">
                  <svg
                    className="h-12 w-12 text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showVideo && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm">
          <div className="relative w-full max-w-4xl px-6">
            {/* Close button */}
            <button
              onClick={handleCloseVideo}
              className="absolute top-2 right-2 text-white text-3xl font-bold z-50"
            >
              &times;
            </button>

            {/* Vimeo Player Embed */}
            <div className="relative pt-[56.25%] rounded-xl overflow-hidden shadow-lg">
              <iframe
                src="https://player.vimeo.com/video/1076885109?h=002f5220c2&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                allowFullScreen
                title="Demo video "
                className="absolute top-0 left-0 w-full h-full"
              ></iframe>
            </div>
          </div>
        </div>
      )}

      {/* About Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-gray-800 rounded-3xl p-8 shadow-xl">
          <h2 className="text-3xl font-bold mb-6">About This Course</h2>
          <p className="text-gray-300 leading-relaxed mb-8">{course.about}</p>
          <h3 className="text-2xl font-bold mb-4">What You'll Learn</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {course.whatYouWillLearn.map((item, index) => (
              <div key={index} className="flex items-start">
                <svg
                  className="h-6 w-6 text-indigo-400 mr-3 mt-1"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="text-gray-300">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Course Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-gray-800 rounded-3xl p-8 shadow-xl">
          <h2 className="text-3xl font-bold mb-6">Course Content</h2>
          <div className="flex items-center justify-between text-gray-400 mb-6">
            <span>
              {course.modules.length} modules • {course.duration}
            </span>
            <button className="text-indigo-400 font-medium hover:text-indigo-300">
              Expand All
            </button>
          </div>
          <div className="space-y-4">
            {course.modules.map((module) => (
              <div
                key={module.id}
                className="border border-gray-700 rounded-xl overflow-hidden bg-gray-900"
              >
                <div
                  className={`flex justify-between items-center p-5 cursor-pointer ${
                    expandedModule === module.id
                      ? "bg-indigo-900"
                      : "bg-gray-900"
                  }`}
                  onClick={() => toggleModule(module.id)}
                >
                  <div className="flex items-center">
                    <div
                      className={`w-10 h-10 rounded-full flex items-center justify-center mr-4 ${
                        expandedModule === module.id
                          ? "bg-indigo-600 text-white"
                          : "bg-gray-700 text-gray-300"
                      }`}
                    >
                      {module.id}
                    </div>
                    <div>
                      <h3 className="font-semibold text-white">
                        {module.title}
                      </h3>
                      <p className="text-sm text-gray-400">
                        {module.duration} • {module.lessons.length} lessons
                      </p>
                    </div>
                  </div>
                  <svg
                    className={`h-5 w-5 text-gray-400 ${
                      expandedModule === module.id ? "rotate-180" : ""
                    }`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                {expandedModule === module.id && (
                  <div className="p-5 border-t border-gray-700">
                    <ul className="space-y-3">
                      {module.lessons.map((lesson, index) => (
                        <li
                          key={index}
                          className="flex justify-between items-center py-2 px-3 rounded-lg hover:bg-gray-800"
                        >
                          <div className="flex items-center">
                            {lesson.isVideo ? (
                              <svg
                                className="h-5 w-5 text-indigo-400 mr-3"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            ) : (
                              <svg
                                className="h-5 w-5 text-orange-400 mr-3"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            )}
                            <span className="text-gray-300">
                              {lesson.title}
                            </span>
                          </div>
                          <span className="text-sm text-gray-500">
                            {lesson.duration}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Certificate Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-gray-800 rounded-3xl p-8 shadow-xl">
          <h2 className="text-3xl font-bold mb-6 text-white">
            Earn a Certificate
          </h2>
          <div className="flex flex-col md:flex-row items-center gap-8">
            {/* Certificate Preview Box */}
            <div className="w-full md:w-1/3">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-indigo-600/30 to-purple-600/30 rounded-2xl"></div>
                <div className="relative border-4 border-indigo-500 p-6 rounded-2xl bg-gray-900 shadow-lg transform hover:scale-105 transition-all duration-300">
                  <div className="border-4 border-indigo-400 border-dashed p-4 rounded-lg">
                    <div className="text-center">
                      <h3 className="text-xl font-bold text-white mb-2">
                        Certificate of Completion
                      </h3>
                      <p className="text-gray-400 text-sm mb-4">
                        {course.title}
                      </p>
                      {/* Certificate Image Preview */}
                      <div className="h-40 w-full flex items-center justify-center bg-gray-800 rounded mb-4 overflow-hidden">
                        <img
                          src={certificateImg}
                          alt="certificate demo"
                          className="h-full object-contain"
                        />
                      </div>
                      <p className="text-xs text-gray-500">
                        Certified by Industry Experts
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Certificate Description */}
            <div className="w-full md:w-2/3">
              <h3 className="text-2xl font-bold mb-3 text-white">
                {course.certificate.title}
              </h3>
              <p className="text-gray-300 mb-4">
                {course.certificate.description}
              </p>
              <div className="bg-gray-900 p-4 rounded-lg border border-gray-700">
                <h4 className="font-semibold text-indigo-400 mb-2">
                  Requirements:
                </h4>
                <p className="text-gray-300">
                  {course.certificate.requirements}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Instructor Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-gray-800 rounded-3xl p-8 shadow-xl">
          <h2 className="text-3xl font-bold mb-6">Meet Your Instructor</h2>
          <div className="flex flex-col md:flex-row items-start gap-6">
            <div className="w-32 h-32 rounded-full overflow-hidden flex-shrink-0">
              <img
                src={instructorImg}
                alt={course.instructor.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold">{course.instructor.name}</h3>
              <p className="text-indigo-400 font-medium mb-3">
                {course.instructor.title}
              </p>
              <div className="flex flex-wrap gap-4 mb-4">
                <div className="flex items-center">
                  <svg
                    className="h-5 w-5 text-yellow-400 mr-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                  <span>{course.instructor.rating} Rating</span>
                </div>
                <div className="flex items-center">
                  <svg
                    className="h-5 w-5 text-indigo-400 mr-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>{course.instructor.courses} Courses</span>
                </div>
                <div className="flex items-center">
                  <svg
                    className="h-5 w-5 text-indigo-400 mr-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                  </svg>
                  <span>
                    {course.instructor.students.toLocaleString()} Students
                  </span>
                </div>
              </div>
              <p className="text-gray-300 leading-relaxed">
                {course.instructor.bio}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Pricing Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-gradient-to-r from-indigo-900 to-purple-900 rounded-3xl p-8 shadow-xl text-center">
          <h2 className="text-3xl font-bold mb-4">Join the Course Today!</h2>
          <div className="flex items-center justify-center mb-6">
            <span className="text-4xl font-extrabold">
              ₹{course.price.discounted}
            </span>
            <span className="text-xl text-gray-400 line-through ml-4">
              ₹{course.price.original}
            </span>
            <span className="ml-4 bg-red-600 text-white px-3 py-1 rounded-full">
              {course.price.discount}% OFF
            </span>
          </div>
          <p className="text-gray-300 mb-6">
            Limited time offer! Enroll now and start your journey.
          </p>
          <button
            onClick={() => navigate("/enroll")}
            className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-bold py-4 px-10 rounded-xl hover:from-indigo-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            Enroll Now
          </button>
          <div className="mt-6 space-y-4">
            <div className="flex items-center justify-center">
              <svg
                className="h-5 w-5 text-indigo-400 mr-2"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                  clipRule="evenodd"
                />
              </svg>
              <span>Full lifetime access</span>
            </div>
            <div className="flex items-center justify-center">
              <svg
                className="h-5 w-5 text-indigo-400 mr-2"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10.5 18a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3zm-6.75-4.5A3.375 3.375 0 003.75 4.875v14.25A3.375 3.375 0 007.125 22.5h9.75a3.375 3.375 0 003.375-3.375V4.875A3.375 3.375 0 0016.875 1.5h-9.75zM6.75 4.875c0-.621.504-1.125 1.125-1.125h8.25c.621 0 1.125.504 1.125 1.125v14.25c0 .621-.504 1.125-1.125 1.125h-8.25a1.125 1.125 0 01-1.125-1.125V4.875z"
                  clipRule="evenodd"
                />
              </svg>
              <span>Access on mobile and desktop</span>
            </div>
            <div className="flex items-center justify-center">
              <svg
                className="h-5 w-5 text-indigo-400 mr-2"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M7.5 5.25a3 3 0 013-3h3a3 3 0 013 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0112 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 017.5 5.455V5.25z"
                  clipRule="evenodd"
                />
              </svg>
              <span>Certificate of completion</span>
            </div>
            <div className="flex items-center justify-center">
              <svg
                className="h-5 w-5 text-indigo-400 mr-2"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4.804 21.644A6.707 6.707 0 006 21.75a6.721 6.721 0 003.583-1.029c.774.182 1.584.279 2.417.279 5.322 0 9.75-3.97 9.75-9 0-5.03-4.428-9-9.75-9s-9.75 3.97-9.75 9c0 2.409 1.025 4.587 2.674 6.192.232.226.277.428.254.543a3.73 3.73 0 01-.814 1.686.75.75 0 00.44 1.223z"
                  clipRule="evenodd"
                />
              </svg>
              <span>24/7 support</span>
            </div>
          </div>
          <p className="text-gray-400 text-sm mt-6">
            30-Day Money-Back Guarantee
          </p>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="text-3xl font-bold text-center mb-12">
          Frequently Asked Questions
        </h2>
        <div className="space-y-6">
          <FaqItem
            question="How long do I have access to the course?"
            answer="You will have lifetime access to the course content, including all future updates. Once you enroll, you can access the course anytime, anywhere."
          />
          <FaqItem
            question="Is there a certificate upon completion?"
            answer="Yes, upon successful completion of all course modules and the final project, you'll receive a verified certificate that you can share with employers and on your professional profiles."
          />
          <FaqItem
            question="What if I'm not satisfied with the course?"
            answer="We offer a 30-day money-back guarantee. If you're not satisfied with the course for any reason, you can request a full refund within 30 days of purchase."
          />
          <FaqItem
            question="Do I need prior experience to take this course?"
            answer="Basic knowledge of HTML, CSS, and JavaScript is recommended. However, we provide resources to help beginners catch up if needed."
          />
          <FaqItem
            question="How is this course different from other web development courses?"
            answer="This course focuses on practical, real-world applications rather than just theory. You'll build actual projects that you can add to your portfolio, and you'll learn the latest industry best practices from an experienced instructor."
          />
        </div>
      </div>
    </div>
  );
}

// Helper Components
function FaqItem({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-gray-800 rounded-xl overflow-hidden shadow-lg">
      <button
        className="w-full text-left p-6 flex justify-between items-center focus:outline-none hover:bg-gray-700 transition-all duration-300"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 className="text-lg font-semibold">{question}</h3>
        <svg
          className={`h-5 w-5 text-indigo-400 ${isOpen ? "rotate-180" : ""}`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      {isOpen && (
        <div className="px-6 pb-6">
          <p className="text-gray-300">{answer}</p>
        </div>
      )}
    </div>
  );
}

export default CourseDetails;
